import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { OrganizationsService } from '../../services/organizations.service'
import { environment } from 'src/environments/environment'
import { Subscription } from 'rxjs'
import { BranchInformationModel } from '../../models/branch-information.model'
import { OwlOptions } from 'ngx-owl-carousel-o'
import { OrganizationSliderUploaderComponent } from '../organization-slider-uploader/organization-slider-uploader.component'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'

@Component({
	selector: 'app-organization-branch-slider',
	templateUrl: './organization-branch-slider.component.html',
	styleUrls: ['./organization-branch-slider.component.scss'],
})
export class OrganizationBranchSliderComponent implements OnInit, OnDestroy {
	@Input() branchInformationData!: BranchInformationModel
	@Output() updateData: EventEmitter<any> = new EventEmitter()
	Subscription = new Subscription()
	attachmentUrl = environment.attachmentPath
	coverConfig: ImageUpload = {
		imageCropDimensions: 3 / 1.3,
		imageWidth: 1550,
		imageHeight: 500,
	}
	mobileConfig: ImageUpload = {
		imageCropDimensions: 138 / 125,
		imageWidth: 414,
		imageHeight: 375,
	}
	customOptions: OwlOptions = {
		loop: false,
		touchDrag: true,
		dots: true,
		nav: false,
		navSpeed: 700,
		items: 1,
	}
	newUploadedImage: { url: string; coverViewUrl: string } = {
		url: '',
		coverViewUrl: '',
	}
	openMenu = false
	coverImage: any
	mobileImage: any

	constructor(
		private dialog: MatDialog,
		private organizationsService: OrganizationsService,
		private toaster: ToastrService,
		private translate: TranslateService
	) {}

	ngOnInit(): void {}

	uploadSliderImage(): void {
		const dialogRef = this.dialog.open(OrganizationSliderUploaderComponent, {
			width: '752px',
			height: '500px',
			panelClass: 'overflow-y-auto',
			data: {
				cover: this.coverConfig,
				mobile: this.mobileConfig,
				type: 'cover',
			},
		})

		dialogRef.afterClosed().subscribe((result: any) => {
			if (result) {
				this.uploadImage(result.selectedFile, 'cover')
				this.coverImage = result.selectedFile
				this.uploadMobileImage()
			}
		})
	}
	uploadMobileImage(): void {
		const dialogRef = this.dialog.open(OrganizationSliderUploaderComponent, {
			width: '752px',
			height: '500px',
			panelClass: 'overflow-y-auto',
			data: {
				cover: this.coverConfig,
				mobile: this.mobileConfig,
				type: 'mobile',
			},
		})

		dialogRef.afterClosed().subscribe((result: any) => {
			if (result) {
				this.mobileImage = result.selectedFile
				// let images = {
				// 	this.coverImage
				// }
				this.uploadImage(result.selectedFile, 'mobile')
			}
		})
	}

	uploadImage(file: { croppedCover: File; croppedMobile: File }, type: string) {
		const formData = new FormData()
		formData.append('image', file.croppedCover)
		this.Subscription.add(
			this.organizationsService
				.UploadSliderImage(formData)
				.subscribe((response: any) => {
					type == 'cover'
						? (this.newUploadedImage.coverViewUrl = response?.result?.url)
						: (this.newUploadedImage.url = response?.result?.url)
					type == 'mobile' ? this.handleBeforSave(false) : null
				})
		)
	}

	handleBeforSave(isDelete: boolean, index: number = -1) {
		let images: any[] = []
		if (isDelete) {
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '585px',
					data: {
						image: 'assets/images/correct.svg',
						flex: true,

						message: this.translate.instant(
							'CONFIRMATION_MESSAGE.DELETE_IMAGE',
							{
								name: this.branchInformationData?.name,
							}
						),

						cancelBtn: 'ACTIONS.NO',
						confirmBtn: 'ACTIONS.YES',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (res) {
							images = [...this.branchInformationData.sliderImages]
							images.splice(index, 1)
							this.updateImage(images)
						}
					},
				})
		} else {
			images = [
				{ ...this.newUploadedImage },
				...this.branchInformationData.sliderImages,
			]
			this.updateImage(images)
		}
	}

	updateImage(images: any) {
		const body = {
			id: this.branchInformationData?.id,
			tenantId: this.branchInformationData.tenantId,
			sliderUrls: images,
		}
		this.Subscription.add(
			this.organizationsService.updateSliderImage(body).subscribe((res) => {
				this.updateData.emit()
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
			})
		)
	}

	setImgAsDefaul(id: any) {
		this.Subscription.add(
			this.organizationsService.SetSlider(id).subscribe((res) => {
				this.branchInformationData.sliderImages =
					this.branchInformationData.sliderImages.map((img) => {
						return { ...img, isDefault: false }
					})
				let defaultImg = this.branchInformationData.sliderImages.find(
					(img) => img.id == id
				)
				if (defaultImg) {
					defaultImg.isDefault = true
				}
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
			})
		)
	}
	// getController(controlName: any) {
	// 	return controlName as FormControl
	// }
	ngOnDestroy(): void {
		this.Subscription.unsubscribe()
	}
}
